export default __webpack_public_path__ + "static/media/frame_en_sp-landscape.3fea3f97.png";